export default {
    raw_data_tab_filter_by_last: "Last",
    raw_data_tab_filter_by_date: "Range",
    raw_data_tab_apply_filters: "Apply",
    raw_data_tab_id: "Row Id",
    raw_data_tab_server_time: "Server Time",
    raw_data_tab_unit_time: "Unit Time",
    raw_data_tab_latitude: "Latitude",
    raw_data_tab_longitude: "Longitude",
    raw_data_tab_raw_event: "Raw Event",
    raw_data_tab_dist: "Dist",
    raw_data_tab_speed: "GPS Speed",
    raw_data_tab_ecu_speed: "ECU Speed",
    raw_data_tab_gps_event_address: "Address",
    raw_data_tab_landmark_id: "Landmark ID",
    raw_data_tab_satellites: "Satellites",
    raw_data_tab_inputs: "Inputs",
    raw_data_tab_raw: "Raw Data",
    raw_data_tab_raw_data_modal_title: "Raw data",
    raw_data_tab_raw_data_modal_cancel: "Cancel",
    raw_data_tab_raw_data_modal_copy: "Copy",
    raw_data_tab_raw_data_modal_copied: "Copied",
    raw_data_tab_accumulator: "ACC",
    raw_data_tab_type: "MSG Type",
    raw_data_tab_update_time: "Update time",
    raw_data_tab_fix_time: "Fix time",
    raw_data_tab_recived_at: "Received at",
    raw_data_tab_direction: "Direction",
    raw_data_tab_altitude: "Altitude",
    raw_data_tab_event: "Event Name",
    raw_data_tab_network_id: "Network Id",
    raw_data_tab_unit_status: "Unit Status",
    raw_data_tab_seq_num: "Seq Num",
    raw_data_tab_msg_id: "MSG Id",
    raw_data_tab_fix_status: "Fix Status",
    raw_data_tab_comm_state: "Comm State",
    raw_data_tab_records: "records",
    raw_data_tab_heading: "Heading",
    raw_data_tab_ignition: "Ignition",
    raw_data_tab_ignition_on: "On",
    raw_data_tab_ignition_off: "Off",
    raw_data_tab_event_received: "Event Received",
    raw_data_tab_update_time: "Update Time",
    raw_data_tab_fix_time: "Fix Time",
    raw_data_tab_fix_status: "Fix Status",
    raw_data_tab_received_at: "Received At",
    raw_data_tab_message_type: "MSG Type",
    raw_data_tab_device_id: "Device Id",
    raw_data_tab_satellites: "Satellites",
    raw_data_tab_hdop: "Hdop",
    raw_data_tab_direction: "Direction",
    raw_data_tab_event_code: "Raw Event",
    raw_data_tab_event_index: "Event Index",
    raw_data_tab_accumulator_count: "Accumulator Count",
    raw_data_tab_accumulator0: "Accumulator 0",
    raw_data_tab_accumulator1: "Accumulator 1",
    raw_data_tab_accumulator2: "Accumulator 2",
    raw_data_tab_accumulator3: "Accumulator 3",
    raw_data_tab_accumulator4: "Accumulator 4",
    raw_data_tab_accumulator5: "Accumulator 5",
    raw_data_tab_accumulator6: "Accumulator 6",
    raw_data_tab_accumulator7: "Accumulator 7",
    raw_data_tab_accumulator8: "Accumulator 8",
    raw_data_tab_accumulator9: "Accumulator 9",
    raw_data_tab_accumulator10: "Accumulator 10",
    raw_data_tab_accumulator11: "Accumulator 11",
    raw_data_tab_accumulator12: "Accumulator 12",
    raw_data_tab_accumulator13: "Accumulator 13",
    raw_data_tab_accumulator14: "Accumulator 14",
    raw_data_tab_accumulator15: "Accumulator 15",
    raw_data_tab_accumulator16: "Accumulator 16",
    raw_data_tab_accumulator17: "Accumulator 17",
    raw_data_tab_accumulator18: "Accumulator 18",
    raw_data_tab_accumulator19: "Accumulator 19",
    raw_data_tab_accumulator20: "Accumulator 20",
    raw_data_tab_accumulator21: "Accumulator 21",
    raw_data_tab_accumulator22: "Accumulator 22",
    raw_data_tab_accumulator23: "Accumulator 23",
    raw_data_tab_accumulator24: "Accumulator 24",
    raw_data_tab_accumulator25: "Accumulator 25",
    raw_data_tab_accumulator26: "Accumulator 26",
    raw_data_tab_accumulator27: "Accumulator 27",
    raw_data_tab_accumulator28: "Accumulator 28",
    raw_data_tab_accumulator29: "Accumulator 29",
    raw_data_tab_accumulator30: "Accumulator 30",
    raw_data_tab_accumulator31: "Accumulator 31",
    raw_data_tab_comm_state: "Comm State",
    raw_data_tab_rssi: "Rssi",
    raw_data_tab_network_id: "Netwrk Id",
    raw_data_tab_inputs: "Inputs",
    raw_data_tab_unit_state: "Unit State",
    raw_data_tab_seq_num: "# Seq",
    raw_data_tab_msg_route: "Msg Route",
    raw_data_tab_app_msg: "App Msg",
    raw_data_tab_app_msg_type: "App Msg Type",
    raw_data_tab_user_msg: "User Msg",
    raw_data_tab_mobile_id: "Mobile Id",
    raw_data_tab_raw_data: "Raw Data",
    raw_data_tab_db_time_spam: "Db Time Spam",
    raw_data_tab_gateway_received_at: "Received At",
    raw_data_tab_event_time: "Event Time",
    raw_data_tab_serial_number: "Serial Number",
    raw_data_tab_event_text: "Event Text",
    raw_data_tab_fix_age: "Fix Age",
    raw_data_tab_ignition_duration: "Ignition Duration",
    raw_data_tab_total_idle_duration: "Total Idle Duration",
    raw_data_tab_duration: "Duration",
    raw_data_tab_fence_id: "FenceId",
    raw_data_tab_batt_volt: "Batt Volt",
    raw_data_tab_int_batt_volt: "Int Batt Volt",
    raw_data_tab_ack_req: "Ack Req",
    raw_data_tab_format_checksum: "Format Checksum",
    raw_data_tab_format_string: "Format String",
    raw_data_tab_raw_message: "Raw Message",
    raw_data_tab_unavailable_view: "Unavailable View",
    raw_data_tab_action: "Action",
    raw_data_tab_available_break: "Available Break",
    raw_data_tab_available_cycle: "Available Cycle",
    raw_data_tab_available_drive: "Available Drive",
    raw_data_tab_available_shift: "Available Shift",
    raw_data_tab_event_type: "Event Type",
    raw_data_tab_gps_source: "Gps Source",
    raw_data_tab_location: "Location",
    raw_data_tab_gaintimehowmuch: "Gain Time How Much",
    raw_data_tab_gaintimewhen: "Gain Time When",
    raw_data_tab_gaintimewhich: "Gain Time Which",
    raw_data_tab_mobileosversion: "Mobile Os Version",
    raw_data_tab_name: "Name",
    raw_data_tab_nextviolation: "Next Violation",
    raw_data_tab_nextviolationtimestamp: "Next Violation Timestamp",
    raw_data_tab_softwareversion: "Software Version",
    raw_data_tab_speedkm: "Speed Km",
    raw_data_tab_uncertifiedlogs: "Uncertified Logs",
    raw_data_tab_vbusconnected: "Vbus Connected",
    raw_data_tab_vehiclepoweron: "Vehicle Power On",
    raw_data_tab_hdop: "HDop",
    raw_data_tab_vdop: "VDop",
    raw_data_tab_speed_limit: "Speed Limit",
    raw_data_tab_ignition_status: "Ignition Status",
    raw_data_tab_notification_type: "Notification Type",
    raw_data_tab_trip_id: "Trip Id",
    raw_data_tab_picture_id: "Picture Id",
    raw_data_tab_event_category: "Event Category",
    raw_data_tab_event_level: "Event Level",
    raw_data_tab_camera_clip_key: "Camera Clip Key",
    raw_data_tab_camera_clip_offset: "Camera Clip Offset",
    raw_data_tab_clip_id: "Clip Id",
    raw_data_tab_duration: "Duration",
    raw_data_tab_rotate: "Rotate",
    raw_data_tab_camera_status: "Camera Status",
    raw_data_tab_idle_status: "Idle Status",
    raw_data_tab_sdcard_status: "SDCard Status",
    raw_data_tab_data_usage_in_kb: "Data Usage In KB",
    raw_data_tab_transaction_id: "Transaction Id",
    raw_data_tab_status: "Status",
    raw_data_tab_error_msg: "Error Msg",
    raw_data_tab_valid_time_range: "Valid Time Range",
    raw_data_tab_warning: "Warning",
    raw_data_tab_last_message_time: "Last Message Time",
    raw_data_tab_account_id: "Account Id",
    raw_data_tab_date_range: "Please select a valid date range",
    raw_data_tab_sequenceNumber: "Sequence #",
    raw_data_tab_driver_name: "Driver Name",
    raw_data_tab_device_reading_info: "Device Reading Info",
    raw_data_tab_distance: "Distance",
    raw_data_tab_accumulated_distance: "Accumulated Distance",
    raw_data_tab_engine_hours: "Engine Hours",
    raw_data_tab_engine_odometer: "Engine Odometer",
    raw_data_tab_hdop: "HDOP",
    raw_data_tab_vdop: "VDOP",
    raw_data_tab_rssi: "RSSI",
    raw_data_tab_ecu_engine_hours: "ECU Engine Hours",
    raw_data_tab_ecu_engine_odometer: "ECU Engine Odometer",
    raw_data_tab_battery_level: "Battery Level",
    raw_data_tab_engineHours_off: "Engine Hours + Off",
    raw_data_tab_ecu_engineHours_off: "ECU Engine Hours + Off",
    raw_data_tab_engineOdometer_off: "Engine Odometer + Off",
    raw_data_tab_ecu_engineOdometer_off: "ECU Engine Odometer + Off",
    raw_data_tab_video_player: "Play video",
  };
  
  
  
  
  
  
  
  